import React, { useState } from 'react';

export type LayoutType = {
  title: string;
};

type LayoutContextType = {
  layout: LayoutType,
  setLayout: (val: LayoutType) => void
};

const LayoutContext = React.createContext<LayoutContextType>({} as LayoutContextType);

export const LayoutProvider = ({ children }: React.PropsWithChildren) => {
  const [layout, setLayout] = useState<LayoutType>({ title: '' });

  return (
    <LayoutContext.Provider value={{ layout, setLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
